import type { FaireProductEntity } from "../../entity_types/product";

export const p_yqkmp8hexz: FaireProductEntity = {
  token: "p_yqkmp8hexz",
  type: "product",
  name: "Coconut Coffee Pecans & Macadamias",
  brandName: "Kauai Gourmet Nuts",
  imageUrl:
    "https://cdn.faire.com/fastly/471e509720db8a3f8902de4ffa9969964b098cadddeb01c74d6861d0fcbfb370.jpeg",
  priceDollars: 5.15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/506e6044d4f9359355fcc2651aa71bb336d3176d5d89b4f5f090340eb9b482f7.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
